import { PropsWithChildren } from 'react';

type InfoBlockProps = {
  title: string;
};

export const InfoBlock = ({ title, children }: PropsWithChildren<InfoBlockProps>) => (
  <div className="flex flex-col gap-6 w-[30%]">
    <span className="text-l-sb text-base-5">{title}</span>
    <div className="flex flex-col gap-8">{children}</div>
  </div>
);
